export default function getImgNameFromURL(url) {
    // Use URL object to handle edge cases and extract the pathname
    const path = new URL(url).pathname;

    // Split the path by '/' and get the last part, which should be the filename
    const fileName = path.split('/').pop();

    return fileName;
}
